/* esm.sh - applesauce-core@5.2.0/operations/tags */
export * from "/*applesauce-core@5.2.0/esnext/operations/tags.mjs";
